import { getQueryParamsAsObject } from 'lib/utils/url';
import validate from 'lib/utils/validationRules';

import { FULL_PARAMETERS, PAYMENT_PARAMETERS, SENDER_PARAMETERS } from 'definitions/payment';

const MAX_LENGTH_TEXT = 255;

const ONLY_NUMBER_REG_EXP = /^\d+$/;

function checkAmount(amount) {
  if (validate.isUndefined(amount)) {
    return false;
  }
  return ONLY_NUMBER_REG_EXP.test(amount);
}

function checkText({ comment, message, address }) {
  if (validate.isNotUndefined(comment)) {
    return comment.length <= MAX_LENGTH_TEXT;
  }
  if (validate.isNotUndefined(message)) {
    return message.length <= MAX_LENGTH_TEXT;
  }
  if (validate.isNotUndefined(address)) {
    return address.length <= MAX_LENGTH_TEXT;
  }
  return false;
}

function getText({ comment, message, address }) {
  if (validate.isNotUndefined(comment)) {
    return { comment };
  }
  if (validate.isNotUndefined(message)) {
    return { message };
  }
  if (validate.isNotUndefined(address)) {
    return { address };
  }
  return null;
}

function getReadonly(values) {
  const preparedValues = values
    .split(',')
    .filter(value => [...PAYMENT_PARAMETERS, ...SENDER_PARAMETERS].includes(value))
    .join(',');

  return { readonly: preparedValues };
}

function prepareURL(parameters, readonlyValues) {
  const {
    name,
    email,
    phone,
    comment,
    message,
    address,
    amount,
    readonly,
    action,
    orderId,
    description,
    istest,
  } = parameters;

  const text = { comment, message, address };

  const paymentParams = Object.assign(
    {},
    (checkAmount(amount) && { amount }),
    (validate.isNotUndefined(name) && { name }),
    (validate.isNotUndefined(email) && { email }),
    (validate.isNotUndefined(phone) && { phone }),
    (checkText(text) && getText(text)),
    (validate.isNotEmptyString(readonly) && getReadonly(readonly)),
    (validate.isNotUndefined(action) && { action }),
    (validate.isPositiveInt(Number(orderId)) && { orderId }),
    (validate.isNotUndefined(description) && { description }),
    (validate.isNotUndefined(istest) && { istest: 1 })
  );

  return paymentParams;
}

function getURLParams() {
  const rawString = window.location.search.slice(1);
  const preparedMap = getQueryParamsAsObject(decodeURIComponent(rawString));

  const possibleList = Object.keys(preparedMap)
    .filter(parameter => FULL_PARAMETERS.includes(parameter));

  const filteredMap = possibleList.reduce((acc, curr) => {
    acc[curr] = preparedMap[curr] !== 'undefined' ? preparedMap[curr] : '';
    return acc;
  }, {});

  if (validate.isEmptyObject(filteredMap)) {
    return false;
  }

  const urlParams = prepareURL(filteredMap);

  return urlParams;
}

export {
  getURLParams
};
